import { AYUDA_HIDE, AYUDA_SHOW } from "../../ActionTypes";

export const showAyuda = () => (dispatch) => {
  dispatch({
    type: AYUDA_SHOW,
  });
};

export const hideAyuda = () => (dispatch) => {
  dispatch({
    type: AYUDA_HIDE,
  });
};
